import TimeoutContext from "./TimeoutContext";
import { useContext } from "react";

const useResetTimeout = () => useContext(TimeoutContext);

export default useResetTimeout;
